// extracted by mini-css-extract-plugin
export default {"labelBadge":"LabelBadge_labelBadge__efhqq"};